import { render, staticRenderFns } from "./AttrRss.vue?vue&type=template&id=b12c9316&scoped=true"
import script from "./AttrRss.vue?vue&type=script&lang=js"
export * from "./AttrRss.vue?vue&type=script&lang=js"
import style0 from "./AttrRss.vue?vue&type=style&index=0&id=b12c9316&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b12c9316",
  null
  
)

export default component.exports